/***
 *
 *   LOADER STYLES
 *   The reference's spinner is a ring with one transparent quarter:
 *   `animate-spin rounded-full border-2 border-primary-600 border-t-transparent`
 *   (ui-reference/src/components/tickets/ticket-detail-panel.tsx and the
 *   route pending fallbacks).
 *
 **********/

const Style = {
    base: 'inline-block',
    absolute: 'absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2',
    // `block` matters: this renders as a <span>, and width/height are ignored
    // on an inline box, which collapsed the ring to a 2px line.
    spinner: 'block animate-spin rounded-full border-2 border-primary-600 border-t-transparent',

    // On a coloured surface the ring should take the text colour instead.
    onColor: 'border-current border-t-transparent',
};

export default Style;
